// «Как это работает»: /how-it-works.
//
// Страница для того, кто ещё не начал: пять шагов от пустого экрана до ответа
// и вопросы, которые задают до регистрации, а не после. Тот же текст сервер
// отдаёт роботу прямо в HTML (server/content.mjs) — расходиться им нельзя,
// поэтому он один на двоих и лежит в content/pages.json.
import type { ReactElement } from 'react';
import { useI18n } from '../i18n';
import { pageContent } from '../content';
import { DocLayout } from './DocLayout';
import styles from './DocLayout.module.css';

export function HowItWorksPage(): ReactElement {
  const { lang } = useI18n();
  const c = pageContent(lang).how;

  return (
    <DocLayout title={c.title} description={c.description} lead={c.lead}>
      <h2 className={styles.h2}>{c.stepsTitle}</h2>
      <ol className={styles.steps}>
        {c.steps.map((step) => (
          <li key={step.h} className={styles.step}>
            <h3 className={styles.h3}>{step.h}</h3>
            <p className={styles.text}>{step.p}</p>
          </li>
        ))}
      </ol>

      <h2 className={styles.h2}>{c.faqTitle}</h2>
      <div className={styles.faqList}>
        {c.faq.map((item) => (
          <section key={item.q} className={styles.faq}>
            <h3 className={styles.h3}>{item.q}</h3>
            <p className={styles.text}>{item.a}</p>
          </section>
        ))}
      </div>

      <p className={styles.cta}>
        <a className="btn btn-primary" href="/">
          {c.cta}
        </a>
      </p>
    </DocLayout>
  );
}
